var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_35262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "#FFEBD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 938.5H0V1080H1920V938.5Z",
    fill: "#F98E7D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 945H1920",
    stroke: "#BB6B5E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 981H1920",
    stroke: "#BB6B5E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1017H1920",
    stroke: "#BB6B5E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1053H1920",
    stroke: "#BB6B5E",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1737.1 977.898C1769.46 977.898 1795.7 974.093 1795.7 969.398C1795.7 964.704 1769.46 960.898 1737.1 960.898C1704.74 960.898 1678.5 964.704 1678.5 969.398C1678.5 974.093 1704.74 977.898 1737.1 977.898Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.5 926.099C1708.5 928.699 1700.2 934.899 1693.4 939.399C1688.7 942.499 1684.7 944.799 1684.4 944.599C1683.6 944.099 1682.2 938.399 1683.6 938.399C1683.7 938.399 1683.8 938.299 1683.9 938.199C1686 936.699 1694.6 925.499 1698.7 920.099C1699.9 918.499 1700.8 917.399 1700.9 917.199C1704.5 913.099 1708.6 921.799 1708.5 926.099Z",
    fill: "#CC5E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.91 941.298C1673.01 940.998 1675.31 937.598 1676.31 937.598C1677.21 937.598 1680.31 940.198 1680.31 940.198L1678.51 944.198L1672.91 941.298Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.9 938.299C1682.7 937.999 1680.9 937.799 1680.3 937.099C1679.2 935.999 1678.9 935.999 1677.4 935.199C1676.3 934.699 1675.5 932.099 1674.8 932.499C1674.2 932.799 1674.2 933.399 1674.4 934.199C1674.1 933.899 1673.7 933.799 1673.4 934.599C1672.9 936.199 1671.7 939.999 1671.7 939.999C1671.7 939.999 1672.4 944.199 1672.8 944.499C1673.2 944.699 1676 946.399 1676 946.399C1676 946.399 1683.9 945.299 1684.5 944.499V944.399C1684.5 944.299 1684.6 944.199 1684.6 944.199C1684.8 943.799 1685 943.799 1685.4 943.499V938.699C1685.2 938.599 1684.7 938.499 1683.9 938.299ZM1674.7 935.899C1674.7 935.699 1674.8 935.499 1674.8 935.499C1675.1 936.199 1675.5 936.899 1675.8 937.699V937.799C1676.3 939.399 1676 942.599 1675.2 941.699C1674.7 941.199 1673.7 940.799 1674 939.599C1674.2 938.699 1674.5 936.999 1674.7 935.899Z",
    fill: "#CC5E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.81 944.397C1789.51 944.597 1785.51 942.297 1780.81 939.197C1774.01 934.697 1765.7 928.497 1765.7 925.897C1765.6 921.497 1769.71 912.897 1773.31 917.097C1773.41 917.297 1774.3 918.297 1775.5 919.997C1779.6 925.397 1788.21 936.597 1790.31 938.097C1790.41 938.197 1790.6 938.297 1790.6 938.297C1792.1 938.197 1790.61 943.897 1789.81 944.397Z",
    fill: "#CC5E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.31 940.997C1801.21 940.697 1798.91 937.297 1797.91 937.297C1796.91 937.297 1793.91 939.897 1793.91 939.897L1795.71 943.897L1801.31 940.997Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.81 934.499C1800.51 933.699 1800.11 933.799 1799.81 934.099C1800.11 933.299 1800.11 932.699 1799.41 932.399C1798.61 931.999 1797.91 934.499 1796.81 935.099C1795.31 935.799 1794.91 935.899 1793.91 936.999C1793.21 937.699 1791.51 937.899 1790.31 938.199C1789.51 938.399 1789.01 938.499 1788.91 938.799V943.599C1789.21 943.899 1789.41 943.899 1789.71 944.299C1789.71 944.399 1789.81 944.399 1789.81 944.499V944.599C1790.31 945.399 1798.31 946.499 1798.31 946.499C1798.31 946.499 1801.11 944.799 1801.51 944.599C1801.91 944.399 1802.61 940.099 1802.61 940.099C1802.61 940.099 1801.31 936.099 1800.81 934.499ZM1798.41 937.299C1798.71 936.499 1799.11 935.799 1799.41 935.099C1799.41 935.199 1799.41 935.299 1799.51 935.499C1799.71 936.599 1800.01 938.399 1800.21 939.199C1800.51 940.399 1799.51 940.799 1799.01 941.299C1798.21 942.199 1797.91 938.999 1798.41 937.299C1798.41 937.399 1798.41 937.399 1798.41 937.299Z",
    fill: "#CC5E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.51 944.7C1789.51 944.6 1789.51 944.6 1789.51 944.7C1789.51 944.6 1789.51 944.6 1789.41 944.6C1789.41 944.5 1789.31 944.5 1789.31 944.4C1789.11 944 1788.81 943.5 1788.51 943.1C1787.91 942.2 1787.01 941.4 1785.91 940.7C1784.31 939.6 1782.41 939.3 1780.41 939.5C1772.61 940.3 1763.21 948.5 1762.31 945.5C1761.71 943.6 1760.11 939.9 1758.61 936.5C1757.01 933 1755.51 929.8 1755.21 929.6C1755.01 929.4 1755.71 924.5 1756.71 918.5V918.3C1757.31 914.4 1758.11 910 1758.71 906.4L1758.81 905.9L1758.91 905.5C1759.61 901.2 1760.21 898 1760.21 898C1760.21 898 1764.41 923.3 1765.41 926.3C1771.21 933.6 1778.11 928.6 1775.21 920.4C1774.91 919.5 1774.51 918.7 1773.91 917.7C1772.71 915.9 1771.51 880.9 1766.21 876.7C1764.11 875.1 1760.81 873.4 1757.41 871.9C1754.61 870.7 1751.71 869.6 1749.61 868.8C1747.71 868.1 1746.41 867.7 1746.11 867.5C1745.11 867.1 1741.51 866.6 1741.81 862.5C1742.41 856.1 1750.41 838 1750.01 837.4L1737.01 830L1723.91 837.4C1723.51 838 1728.51 854.8 1728.91 861.6C1729.21 866.4 1728.91 865.5 1727.91 865.9C1727.51 866.1 1725.21 867.1 1722.21 868.5C1720.51 869.3 1718.61 870.3 1716.71 871.3C1713.31 873.1 1710.01 875 1707.91 876.6C1702.51 880.8 1701.41 915.8 1700.21 917.6C1699.71 918.5 1699.21 919.4 1698.91 920.3C1695.91 928.5 1702.91 933.5 1708.71 926.2C1709.71 923.2 1713.91 897.9 1713.91 897.9C1714.11 899 1715.91 909.3 1717.31 917.8C1718.31 924 1719.11 929.3 1718.81 929.4C1718.51 929.6 1716.81 933 1715.21 936.7C1713.71 940 1712.21 943.6 1711.71 945.4C1710.81 948.4 1701.41 940.2 1693.61 939.4C1691.61 939.2 1689.71 939.5 1688.11 940.6C1687.01 941.3 1686.21 942.2 1685.51 943C1685.21 943.4 1684.91 943.8 1684.71 944.3C1684.71 944.4 1684.61 944.4 1684.61 944.5V944.6C1682.21 949.9 1685.81 956.5 1688.71 959.5C1692.51 963.3 1704.41 975.2 1718.51 974.8C1732.61 974.4 1737.11 974.8 1737.11 974.8C1737.11 974.8 1741.71 974.4 1755.71 974.8C1769.81 975.2 1781.71 963.3 1785.51 959.5C1788.41 956.6 1791.91 950 1789.51 944.7Z",
    fill: "#CC604A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.3 823.698C1716.2 821.598 1717.3 818.698 1719.7 819.298C1722.2 815.298 1723.8 812.898 1727.1 814.398C1731.3 812.098 1733.8 810.498 1737 813.598C1738.7 813.498 1740.1 808.998 1744.4 814.198C1746.4 813.498 1751.7 813.398 1753.2 819.198C1753.4 821.198 1757.1 816.998 1757.6 824.298C1757.9 828.398 1761.5 825.598 1760 831.898C1758.3 839.198 1762.3 833.898 1759.9 842.398C1760.7 845.498 1760.4 847.698 1756.7 849.698C1753 851.698 1756.2 853.798 1751.7 854.898C1747 855.998 1750.4 860.498 1744.2 859.798C1738 859.098 1741.9 862.598 1735.6 861.798C1729.3 860.998 1734.1 860.098 1729.5 859.698C1725.4 859.298 1722.9 858.798 1722.9 855.698C1717.6 853.598 1718.3 854.798 1717.4 850.998C1716.7 848.098 1710.8 848.498 1711.7 843.998C1712.2 841.498 1707.6 837.898 1711 833.998C1712 832.898 1709.6 828.998 1712.5 825.998C1715.3 823.098 1714.9 824.698 1715.3 823.698Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.4 959.6C1781.6 963.4 1769.7 975.3 1755.6 974.9C1741.5 974.5 1737 974.9 1737 974.9C1737 974.9 1732.4 974.5 1718.4 974.9C1704.3 975.3 1692.4 963.4 1688.6 959.6C1685.6 956.6 1682.1 950 1684.5 944.7V944.6C1684.5 944.5 1684.6 944.5 1684.6 944.4C1684.8 944 1685.1 943.5 1685.4 943.1C1686 942.2 1686.9 941.4 1688 940.7C1689.6 939.6 1691.5 939.3 1693.5 939.5C1701.3 940.3 1710.7 948.5 1711.6 945.5C1712.2 943.7 1713.7 940.2 1715.1 936.8C1722.5 939.4 1733.4 942.7 1738.9 942.5C1744.1 942.5 1752.9 939 1758.6 936.5C1760.1 939.9 1761.7 943.7 1762.3 945.5C1763.2 948.5 1772.6 940.3 1780.4 939.5C1782.4 939.3 1784.3 939.6 1785.9 940.7C1787 941.4 1787.8 942.3 1788.5 943.1C1788.8 943.5 1789.1 943.9 1789.3 944.4C1789.3 944.5 1789.4 944.5 1789.4 944.6V944.7C1791.9 950 1788.4 956.6 1785.4 959.6Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 899.2L1759 905.3L1758.9 905.7L1758.8 906.2L1756.8 918.1V918.3L1717.3 917.8H1717.2L1714.3 900L1714 897.9C1720.4 896.5 1725.1 890.2 1725.1 883.7C1725.1 878.2 1721.7 873.5 1716.8 871.3C1718.7 870.3 1720.6 869.3 1722.3 868.5C1724 871.3 1727.4 874.6 1736.7 874.8C1743.8 875 1747.8 871.3 1749.7 868.7C1751.8 869.5 1754.7 870.6 1757.5 871.8C1750.3 872.6 1744.6 878.4 1744.6 885.5C1744.6 893.1 1751.1 899.3 1759.1 899.3C1759.5 899.2 1759.5 899.3 1760 899.2Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.8 897.798L1715.3 890.898L1714.6 902.398L1713.8 897.798Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.2 897.799L1759 892.699L1759.4 902.399L1760.2 897.799Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.6 914.898H1757.3",
    stroke: "#3B130B",
    strokeWidth: 0.416,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.8 940.501C1713.8 940.501 1727.2 946.101 1737 946.201C1746.8 946.301 1760.2 939.801 1760.2 939.801",
    stroke: "#3B130B",
    strokeWidth: 0.416,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.6 945.398C1711.6 945.398 1706.8 953.798 1708.5 960.598C1708.5 960.598 1705.9 956.098 1708.5 945.498C1708.5 945.498 1709.4 946.098 1711.6 945.398Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.4 945.398C1762.4 945.398 1767.2 954.698 1765.7 963.598",
    stroke: "#3B130B",
    strokeWidth: 0.416,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725 883.7C1725 883.7 1735.2 877.3 1744.7 883.7",
    stroke: "#3B130B",
    strokeWidth: 0.416,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.9 769.599C1732.4 770.899 1731.3 771.999 1730 777.499C1728.7 771.999 1727.7 770.899 1722.1 769.599C1727.6 768.299 1728.7 767.199 1730 761.699C1731.4 767.299 1732.4 768.299 1737.9 769.599Z",
    fill: "#FFDAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1804.5 815.398C1799.2 816.598 1798.2 817.698 1797 822.898C1795.8 817.598 1794.8 816.598 1789.5 815.398C1794.8 814.198 1795.8 813.098 1797 807.898C1798.2 813.098 1799.2 814.098 1804.5 815.398Z",
    fill: "#FFB6BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.5 827.801C1676.2 829.001 1675.2 830.101 1674 835.301C1672.8 830.001 1671.8 829.001 1666.5 827.801C1671.8 826.601 1672.8 825.501 1674 820.301C1675.2 825.601 1676.2 826.601 1681.5 827.801Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2 991.203C230.946 991.203 242.9 988.517 242.9 985.203C242.9 981.889 230.946 979.203 216.2 979.203C201.454 979.203 189.5 981.889 189.5 985.203C189.5 988.517 201.454 991.203 216.2 991.203Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.402 938.7C215.702 927 217.002 898.3 213.702 887.9C210.402 877.5 204.502 865.6 204.502 865.6C204.502 865.6 202.402 853.2 199.602 851",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.898 857.303C203.898 857.303 205.598 861.703 209.598 864.603C213.598 867.503 218.698 875.803 219.798 878.703C220.898 881.603 221.898 884.703 221.898 884.703C221.898 884.703 224.498 874.503 221.898 867.403C219.298 860.303 214.798 858.003 210.398 857.303C205.998 856.603 203.898 857.303 203.898 857.303Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.104 863.701C196.104 863.701 195.504 865.701 195.304 868.201C195.104 870.701 195.704 874.701 191.304 880.101C186.904 885.501 180.604 893.901 180.504 897.301C180.504 897.301 177.904 889.501 179.404 881.501C180.904 873.501 186.704 865.801 189.904 863.801C193.004 861.701 196.704 861.401 196.104 863.701Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.802 857.003C197.802 857.003 194.702 859.003 191.602 860.803C188.502 862.603 178.202 866.103 173.602 868.303C169.002 870.503 165.102 875.603 165.102 875.603C165.102 875.603 165.302 866.403 169.802 862.103C174.302 857.803 181.502 854.703 186.002 854.703C190.602 854.703 199.502 855.903 197.802 857.003Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.902 852.702C200.902 852.702 195.002 855.301 188.802 853.301C182.702 851.301 174.202 847.001 171.602 847.101C171.602 847.101 179.502 843.002 186.202 843.702C193.002 844.402 204.202 845.502 200.902 852.702Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.699 852.403C202.699 852.403 203.599 847.103 210.399 846.903C217.299 846.703 222.599 850.103 222.599 850.103C222.599 850.103 211.599 853.203 208.199 852.803C204.699 852.503 202.599 854.303 202.699 852.403Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.805 884.702C182.605 873.702 191.705 863.902 196.105 863.602C200.505 863.402 207.005 870.802 207.005 870.802C207.005 870.802 206.605 864.502 205.805 862.902C205.105 861.302 204.105 857.902 204.105 857.902",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.603 865.6C204.603 865.6 200.803 858.5 197.303 857.3C193.803 856.1 180.603 855.1 171.203 864.6",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.902 852.702C200.902 852.702 196.402 843.002 181.102 846.302",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.101 858.903C203.101 858.903 201.001 852.403 204.601 850.503C208.201 848.603 218.201 849.203 218.201 849.203",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.602 921.802C219.902 911.402 225.802 899.502 225.802 899.502C225.802 899.502 227.902 887.102 230.702 884.902",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.398 891.203C226.398 891.203 224.698 895.603 220.698 898.503C216.698 901.403 211.598 909.703 210.498 912.603C209.398 915.503 208.398 918.603 208.398 918.603C208.398 918.603 205.798 908.403 208.398 901.303C210.998 894.203 215.498 891.903 219.898 891.203C224.398 890.403 226.398 891.203 226.398 891.203Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.197 897.502C234.197 897.502 234.797 899.502 234.997 902.002C235.197 904.502 234.597 908.502 238.997 913.902C243.397 919.302 249.697 927.702 249.797 931.102C249.797 931.102 252.397 923.302 250.897 915.302C249.397 907.302 243.597 899.602 240.397 897.602C237.297 895.502 233.597 895.202 234.197 897.502Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.494 890.804C232.494 890.804 235.594 892.804 238.694 894.604C241.794 896.404 252.094 899.904 256.694 902.104C261.294 904.304 265.194 909.404 265.194 909.404C265.194 909.404 264.994 900.204 260.494 895.904C255.994 891.604 248.794 888.504 244.294 888.504C239.694 888.504 230.794 889.804 232.494 890.804Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.399 886.502C229.399 886.502 235.299 889.102 241.499 887.102C247.599 885.102 256.099 880.802 258.699 880.902C258.699 880.902 250.799 876.802 244.099 877.502C237.299 878.202 226.099 879.302 229.399 886.502Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.697 886.204C227.697 886.204 226.797 880.904 219.997 880.704C213.097 880.504 207.797 883.904 207.797 883.904C207.797 883.904 218.797 887.004 222.197 886.604C225.697 886.304 227.797 888.104 227.697 886.204Z",
    fill: "#918C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 918.601C247.697 907.601 238.597 897.801 234.197 897.501C229.797 897.301 223.297 904.701 223.297 904.701C223.297 904.701 223.697 898.401 224.497 896.801C225.297 895.201 226.197 891.801 226.197 891.801",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.797 899.502C225.797 899.502 229.597 892.402 233.097 891.202C236.597 890.002 249.797 889.002 259.197 898.502",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.398 886.503C229.398 886.503 233.898 876.803 249.198 880.103",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.202 892.704C227.202 892.704 229.302 886.204 225.702 884.304C222.102 882.404 212.102 883.004 212.102 883.004",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.802 985.202C227.102 986.002 222.502 986.602 217.302 986.702C211.202 986.802 206.002 986.102 201.802 985.202C200.602 962.002 199.302 938.802 198.102 915.602H234.602L230.802 985.202Z",
    fill: "#FF8353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.002 910.203H193.602V921.003H239.002V910.203Z",
    fill: "#FF8353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.602 921.004H232.602L232.102 926.004C232.102 926.004 225.402 923.304 216.102 923.304C206.802 923.304 199.102 926.004 199.102 926.004L198.602 921.004Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.802 986.603L212.102 921.003H216.502V910.203H238.002V921.003H233.302L230.102 985.203C230.102 985.203 223.602 986.203 214.802 986.603Z",
    fill: "#3B130B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.698 935.402C225.398 944.302 225.198 953.202 224.898 962.102",
    stroke: "#F98E7D",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.101 950.703C229.201 959.703 226.801 970.203 226.901 979.303",
    stroke: "#F98E7D",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5 917.801C204.3 917.801 206.1 917.801 207.8 917.801",
    stroke: "#3B130B",
    strokeWidth: 0.2932,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.402 880.9C132.402 883 130.702 884.8 128.502 893.8C126.402 884.8 124.702 883 115.602 880.9C124.602 878.8 126.302 877 128.502 868C130.702 877.1 132.402 878.8 141.402 880.9Z",
    fill: "#FFDAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.305 852.699C275.005 853.899 274.005 854.999 272.805 860.199C271.605 854.899 270.605 853.899 265.305 852.699C270.605 851.499 271.605 850.399 272.805 845.199C274.005 850.499 275.005 851.499 280.305 852.699Z",
    fill: "#FFB6BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.398 805.301C196.098 806.501 195.098 807.601 193.898 812.801C192.698 807.501 191.698 806.501 186.398 805.301C191.698 804.101 192.698 803.001 193.898 797.801C195.198 803.101 196.198 804.101 201.398 805.301Z",
    fill: "#FFA500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_35262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage17);
export default __webpack_public_path__ + "static/media/image17.f2cb9dc8dfa31a746c2dd14a52927af4.svg";
export { ForwardRef as ReactComponent };